

import React, { useContext, useEffect, useState } from "react";

export default function MarkerPopupNoCredit({ item,showCredit }) {
  
  return (
    <>
      
      <div className="popupMarker"  >
        <div className="row mt-3 "   >
          <div className="col  " >
            <div className="alert alert-danger" role="alert">
              تاریخ اعتبار این دستگاه در پنل به پایان رسیده است.
            </div>
          </div>
        </div>
        <div className="row mt-3 "   >
          <div className="col  " >
            <button
              onClick={showCredit}
              className='btn btn-primary'>
              تمدید اعتبار
            </button>
          </div>
        </div>
      </div>
    </>
  )
}